module.exports = __webpack_public_path__ + "img/682998b.png";